<template>
    <div>
        <el-dialog title="个人简历" :visible.sync="visible" @close="$emit('update:show', false)" width="1080px" :show="show"
                   :close-on-click-modal="false" :close-on-press-escape="false" class="dialogBody">
            <div class="sketch_content">
                <div class="notesBox">
                    <div class="notesTitle">基本信息</div>
                    <div class="mb10" v-if="posttitle">
                        <b>报考岗位：{{posttitle}}（{{positionname}}）</b> &nbsp;&nbsp; <b>报考科室/部门：{{departname}}</b>
                    </div>
                    <table border="1" cellpadding="0" align="center" class="w100">
                        <tr>
                            <td width="130px" align="center" class="backColor">
                                姓名
                            </td>
                            <td width="130px" align="center" colspan="2">
                                {{ previewData.UserName }}
                            </td>
                            <td width="130px" align="center" class="backColor">
                                性别
                            </td>
                            <td width="130px" align="center" colspan="2">
                                <span v-if="previewData.Sex === 0">男</span>
                                <span v-if="previewData.Sex === 1">女</span>
                            </td>
                            <td width="165px" align="center" rowspan="5">
                                <span v-if="previewData.OneselfPhotograph">
                                       <el-image class="notesPic" fit="cover"
                                                 :preview-src-list="[`${BaseURL}/Common/AttachUrl?channeltype=6&filename=${previewData.OneselfPhotograph}`]"
                                                 :src="`${BaseURL}/Common/AttachUrl?channeltype=6&filename=${previewData.OneselfPhotograph}`">
                                       </el-image>
                                </span>
                                <div v-else>
                                    <svg t="1677550038301" class="icon" viewBox="0 0 1026 1024" version="1.1"
                                         xmlns="http://www.w3.org/2000/svg" p-id="10001" width="50" height="50">
                                        <path
                                                d="M969.836327 188.03992H221.764471c-36.279441 0-54.674651 27.081836-54.674651 59.784431v716.391218c0 33.213573 19.417166 59.784431 54.674651 59.784431h748.071856c36.279441 0 54.674651-27.081836 54.674651-59.784431V247.824351c0-33.213573-19.417166-59.784431-54.674651-59.784431zM218.698603 291.257485c0-25.037924 22.483034-45.477046 49.56487-45.477046h654.051896c27.592814 0 49.56487 20.439122 49.564871 45.477046v504.335329l-188.550899-180.375249c-12.774451-11.752495-29.636727-11.752495-42.922155-3.065868l-124.678643 99.12974-142.562874-246.802395c-6.642715-6.131737-12.774451-8.686627-22.994012-11.752495-9.708583 0-16.351297 3.065868-22.994012 8.686627L218.698603 674.491018V291.257485zM975.968064 920.782435c0 25.037924-22.483034 45.477046-49.56487 45.477046H268.774451c-27.592814 0-49.56487-20.439122-49.56487-45.477046v-161.469062l231.984032-234.538922 131.832335 249.357286c9.708583 11.752495 29.636727 11.752495 45.988024 0l132.343313-99.129741 212.055889 204.391218s3.576846 0 3.576846 3.065868v38.323353h-1.021956z m-235.560878-434.842315c36.279441 0 65.40519-27.081836 65.405189-59.784431s-29.636727-59.784431-65.405189-59.784432c-36.279441 0-65.40519 27.081836-65.40519 59.784432s29.125749 59.784431 65.40519 59.784431zM47.520958 159.936128c-1.532934-9.197605 5.620758-17.884232 15.840319-18.906188l746.027945-97.596806c10.219561-1.532934 19.928144 5.10978 20.950099 14.307385l15.329342 74.091816c1.532934 11.241517 12.774451 18.906188 25.548902 17.373254 12.263473-1.532934 20.9501-11.752495 19.417166-22.994012l-15.329342-74.091817c-5.10978-32.191617-37.301397-53.652695-71.536926-49.56487l-745.516966 97.085829C22.483034 104.239521-1.532934 133.876248 3.065868 165.045908l101.173653 648.942116c1.532934 10.219561 11.241517 17.373253 21.972056 17.373253 13.796407 0 24.526946-10.730539 21.972056-23.50499L47.520958 159.936128z"
                                                fill="#B5B5B5" p-id="10002"></path>
                                    </svg>
                                    <div class="text-ccc mt10">个人证件照</div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td width="130px" align="center" class="backColor">
                                出生日期
                            </td>
                            <td width="130px" align="center" colspan="2">
                                {{previewData.BirthDate}}
                            </td>
                            <td width="130px" align="center" class="backColor">
                                民族
                            </td>
                            <td width="130px" align="center" colspan="2">
                                {{previewData.Nation}}
                            </td>
                        </tr>
                        <tr>
                            <td width="130px" align="center" class="backColor">
                                身份证号
                            </td>
                            <td width="130px" align="center" colspan="2">
                                {{previewData.IDCardNumber}}
                            </td>
                            <td width="130px" align="center" class="backColor">
                                身高
                            </td>
                            <td width="130px" align="center" colspan="2">
                                {{previewData.Height}}
                            </td>
                        </tr>
                        <tr>
                            <td width="130px" align="center" class="backColor">
                                政治面貌
                            </td>
                            <td width="130px" align="center" colspan="2">
                                {{previewData.PoliticsStatus}}
                            </td>
                            <td width="130px" align="center" class="backColor">
                                婚姻状况
                            </td>
                            <td width="130px" align="center" colspan="2">
                                <span v-if="previewData.MaritalStatus === 0">未婚</span>
                                <span v-if="previewData.MaritalStatus === 1">已婚</span>
                                <span v-if="previewData.MaritalStatus === 2">离异</span>
                                <span v-if="previewData.MaritalStatus === 3">丧偶</span>
                            </td>
                        </tr>
                        <tr>
                            <td width="130px" align="center" class="backColor">
                                电子邮箱
                            </td>
                            <td width="130px" align="center" colspan="2">
                                {{previewData.Email}}
                            </td>
                            <td align="center" class="backColor">
                                手机号码
                            </td>
                            <td align="center" colspan="2">
                                {{previewData.ContactWay}}
                            </td>
                        </tr>
                        <tr>
                            <td width="130px" align="center" class="backColor">
                                籍贯
                            </td>
                            <td colspan="2" align="center">
                                {{previewData.NativePlace}}
                            </td>
                            <td width="130px" align="center" class="backColor">
                                现户籍地
                            </td>
                            <td colspan="3" align="center">
                                {{previewData.PlaceDomicile}}
                            </td>
                        </tr>
                        <tr>
                            <td width="130px" align="center" class="backColor">
                                通讯地址
                            </td>
                            <td colspan="2" align="center">
                                {{previewData.MailingAddress}}
                            </td>
                            <td width="130px" align="center" class="backColor">
                                邮政编码
                            </td>
                            <td colspan="3" align="center">
                                {{previewData.ZipCode}}
                            </td>
                        </tr>
                        <tr>
                            <td width="130px" align="center" class="backColor">
                                最高学历
                            </td>
                            <td colspan="2" align="center">
                                {{previewData.HighestEducation}}
                            </td>
                            <td width="130px" align="center" class="backColor">
                                学位
                            </td>
                            <td colspan="3" align="center">
                                {{previewData.Degree}}
                            </td>
                        </tr>
                        <tr>
                            <td width="130px" align="center" class="backColor">
                                毕业学校
                            </td>
                            <td colspan="2" align="center">
                                {{previewData.GraduateSchool}}
                            </td>
                            <td width="130px" align="center" class="backColor">
                                毕业时间
                            </td>
                            <td colspan="3" align="center">
                                {{previewData.GraduationDate}}
                            </td>
                        </tr>
                        <tr>
                            <td width="130px" align="center" class="backColor">
                                学习形式
                            </td>
                            <td colspan="2" align="center">
                                {{previewData.LearningStyle}}
                            </td>
                            <td width="130px" align="center" class="backColor">
                                专业
                            </td>
                            <td colspan="3" align="center">
                                {{previewData.Major}}
                            </td>
                        </tr>
                        <tr>
                            <td width="130px" align="center" class="backColor">
                                英语水平等级
                            </td>
                            <td colspan="2" align="center">
                                {{previewData.EnglishLevel}}
                            </td>
                            <td width="130px" align="center" class="backColor">
                                计算机水平等级
                            </td>
                            <td colspan="3" align="center">
                                {{previewData.ComputerLevel}}
                            </td>
                        </tr>
                        <tr>
                            <td width="130px" align="center" class="backColor">
                                参加工作时间
                            </td>
                            <td colspan="2" align="center">
                                {{previewData.worktime}}
                            </td>
                            <td width="130px" align="center" class="backColor">
                                工作单位
                            </td>
                            <td colspan="3" align="center">
                                {{previewData.LastCompany}}
                            </td>
                        </tr>
                        <tr>
                            <td width="130px" align="center" class="backColor">
                                单位性质
                            </td>
                            <td colspan="2" align="center">
                                {{previewData.NatureUnit}}
                            </td>
                            <td width="130px" align="center" class="backColor">
                                最高专业技术资格
                            </td>
                            <td colspan="3" align="center">
                                {{previewData.ProfessionalSkill}}
                            </td>
                        </tr>
                        <tr>
                            <td width="130px" align="center" class="backColor">
                                职称
                            </td>
                            <td colspan="2" align="center">
                                {{previewData.Post}}
                            </td>
                            <td width="130px" align="center" class="backColor">
                                执业资格
                            </td>
                            <td colspan="3" align="center">
                                {{previewData.PracticeCertificate}}
                            </td>
                        </tr>
                    </table>
                    <div class="notesTitle mt15">学习经历</div>
                    <el-table :data="previewData.StudyList" style="width: 100%"
                              :header-cell-style='{background:"#f1fbfb",fontWeight:"normal",fontSize:"14px",color: "#333333"}'>
                        <el-table-column type="index" label="序号" align="center" width="55"/>
                        <el-table-column prop="StudyStartDate" label="学习开始时间" align="center" min-width="100"/>
                        <el-table-column prop="StudyEndDate" label="学习结束时间" align="center" min-width="100"/>
                        <el-table-column label="学历" align="center" :show-overflow-tooltip="true" min-width="100">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.EducationID" placeholder="请选择学历" filterable
                                           clearable class="w100" size="small" disabled>
                                    <el-option v-for="dict in EducationNav" :key="dict.dict_code"
                                               :label="dict.dict_label" :value="`${dict.dict_code}`"/>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="GraduationSchool" label="毕业院校" align="center" min-width="100"/>
                        <el-table-column prop="EducationalSystem" label="学制" align="center" min-width="100"/>
                        <el-table-column prop="Major" label="所学专业" align="center" min-width="100"/>
                        <el-table-column label="学习形式" align="center" min-width="120">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.LearningStyleID" placeholder="请选择学习形式" filterable
                                           clearable
                                           class="w100"
                                           size="small" disabled>
                                    <el-option v-for="dict in learningNav" :key="dict.dict_code"
                                               :label="dict.dict_label" :value="dict.dict_code"/>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-empty slot="empty" description="暂无数据"/>
                    </el-table>
                    <div class="notesTitle mt15">工作经历</div>
                    <el-table :data="previewData.WorkList" style="width: 100%"
                              :header-cell-style='{background:"#f1fbfb",fontWeight:"normal",fontSize:"14px",color: "#333333"}'>
                        <el-table-column type="index" label="序号" align="center" width="55"/>
                        <el-table-column prop="WorkStartDate" label="工作开始时间" align="center"/>
                        <el-table-column prop="WorkEndDate" label="工作结束时间" align="center"/>
                        <el-table-column prop="WorkUnit" label="工作单位" align="center"/>
                        <el-table-column prop="ProfessionalTitle" label="职称" align="center"/>
                        <el-table-column prop="Post" label="职务" align="center"/>
                        <el-table-column prop="WorkName" label="主要从事工作" align="center"/>
                        <el-empty slot="empty" description="暂无数据"/>
                    </el-table>
                    <div class="notesTitle mt15">家庭成员</div>
                    <el-table :data="previewData.MemberFamilyList" style="width: 100%"
                              :header-cell-style='{background:"#f1fbfb",fontWeight:"normal",fontSize:"14px",color: "#333333"}'>
                        <el-table-column type="index" label="序号" align="center" width="55"/>
                        <el-table-column prop="UserName" label="姓名" align="center"/>
                        <el-table-column prop="Relationship" label="与本人关系" align="center"/>
                        <el-table-column prop="WorkUnit" label="工作单位" align="center"/>
                        <el-table-column prop="Post" label="职务" align="center"/>
                        <el-table-column prop="PlaceDomicile" label="户籍所在地" align="center"/>
                        <el-empty slot="empty" description="暂无数据"/>
                    </el-table>
                    <div class="notesTitle mt15">其他</div>
                    <div class="mb15">
                        <div class="otherTitle">
                            奖惩情况
                        </div>
                        <div class="otherContent">
                            <div v-if="previewData.HonorCertificates">
                                {{previewData.HonorCertificates}}
                            </div>
                            <div v-else class="text-ccc">
                                暂无奖惩情况
                            </div>
                        </div>
                    </div>
                    <div class="mb15">
                        <div class="otherTitle">
                            个人特长及突出业绩
                        </div>
                        <div class="otherContent">
                            <div v-if="previewData.Characteristic">
                                {{previewData.Characteristic}}
                            </div>
                            <div v-else class="text-ccc">
                                暂无个人特长及突出业绩
                            </div>
                        </div>
                    </div>
                    <div class="mb15">
                        <div class="otherTitle">
                            备注
                        </div>
                        <div class="otherContent">
                            <div v-if="previewData.Remark">
                                {{previewData.Remark}}
                            </div>
                            <div v-else class="text-ccc">
                                暂无备注
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <el-button type="primary" size="small" @click="submitForm">
                        <i class="el-icon-document mr4"/>提交
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        props: {
            show: {
                type: Boolean,
                default: false
            },
            previewData: {
                type: Object,
                default: () => {
                }
            },
        },
        data() {
            return {
                visible: this.show,
                posttitle: "",  // 报考岗位
                positionname: '',   // 报考科室
                departname: '',   // 报考科室
                BaseURL: 'http://zjeyapi2.ypaiban.com/api',
                EducationNav: [],   // 最高学历
                learningNav: [],  // 学习形式
            }
        },
        created() {
            this.getEducationNav()
            this.getLearningNav()
        },
        methods: {
            // 提交
            submitForm() {
                this.$confirm('<div style="text-indent: 22px;line-height: 23px;font-size: 15px;color: #ee0a24;">本人网上提交的资料和照片，必须和提交的纸质版复印件一致，如有不一致，一切后果由本人承担, 是否确认提交?</div>', '提醒注意', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    showClose: false,
                    dangerouslyUseHTMLString: true,
                    customClass: 'newsClass',
                    closeOnClickModal: false,
                }).then(() => {
                    this.myFetch.post("/RecruitManagement/CreateResumeWX", this.previewData).then(res => {
                        if (res.data.code == 0) {
                            this.$confirm('报名信息提交成功！', '系统提示', {
                                confirmButtonText: '确定',
                                type: 'success',
                                showClose: false,
                                customClass: 'newsClass',
                                closeOnClickModal: false,
                                showCancelButton: false
                            }).then(() => {
                                this.$parent.notesModalShow = false
                                location.reload()
                            }).catch(() => {
                            })
                        } else {
                            this.$message.error(res.data.msg)
                        }
                    }).catch(e => {
                        this.$message({
                            message: "网络或程序异常！" + e,
                            type: "error"
                        });
                    })
                }).catch(() => {
                })
            },

            // 最高学历
            getEducationNav() {
                this.baseFetch.post("/SysDictData/GetList", {dict_type: 'recruit_education'}).then(res => {
                    this.EducationNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },

            // 学习形式
            getLearningNav() {
                this.baseFetch.post("/SysDictData/GetList", {dict_type: 'Learning_form'}).then(res => {
                    this.learningNav = res.data.data
                }).catch(e => {
                    this.$message({
                        message: "网络或程序异常！" + e,
                        type: "error"
                    });
                });
            },
        },
        watch: {
            show(val) {
                this.visible = this.show
                if (!val) {
                    for (let key in this.previewData) {
                        this.previewData[key] = ''
                        this.previewData.StudyList = []
                        this.previewData.WorkList = []
                        this.previewData.MemberFamilyList = []
                    }
                    this.$parent.completionRate = 84
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .notesBox {
        .notesTitle {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 10px;
            position: relative;

            &:before {
                content: '|';
                color: #409eff;
                margin-right: 5px;
            }
        }

        table {
            border-collapse: collapse;
            width: 100%;
        }


        table td {
            color: #666;
            height: 38px;
            text-align: center;
        }

        .notesPic {
            width: 100%;
            height: 193px;
            display: block;
            object-fit: cover;
        }
    }

    .otherTitle {
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 7px;
    }

    .otherContent {
        font-size: 16px;
    }

    ::v-deep .el-input.is-disabled .el-input__inner {
        border: 0;
        background-color: initial;
        border-color: initial;
        color: #333333;
        cursor: default;
        padding: 0 8px !important;
        text-align: center;
    }

    ::v-deep .el-icon-arrow-up:before {
        content: '';
    }

    .backColor {
        background: #dbf5f5;
    }
</style>
